"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDictList = getDictList;
exports.getTechnicalDocumentsById = getTechnicalDocumentsById;
var _request = _interopRequireDefault(require("@/utils/request"));
/**
 * 第一步先查出来对应的字典项（用户注册文档ID），
 *
 */

/**
 *获取对应类型的字典项
 *
 */
function getDictList() {
  return (0, _request.default)({
    url: '/equery/pigSysDict/type/getDocumentID',
    headers: {
      TenantId: '2'
    },
    method: 'get'
  });
}

/**
 * 根据文档id,获取对应文档内容
 * @param id
 */
function getTechnicalDocumentsById(id) {
  return (0, _request.default)({
    url: '/equery/sysTechnicalDocuments/getById/' + id,
    method: 'get'
  });
}